export default __webpack_public_path__ + "static/Sequel-100-Wide-75-e13abf785d34f0aaf02d100c44177699.ttf";